import { Component, OnInit } from '@angular/core';
import { AplicacionServices } from './Service/aplicacion.services';
import { MensajeServices } from './Service/messages.services';
import { Alertas, TiposAlerta } from './recursos/alertas';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent implements OnInit{
  title = 'ActDatosCciales';
  SoloAdmin:boolean = false;
  RedirectThkPag:boolean = false;
  AppServices = AplicacionServices;
  UrlThkPage: string;
  MensajeThkPag: string;
  Constantes = {};
  Mensajes = {};
  Alertas: Alertas;

  constructor(private _AplicacionServices:AplicacionServices, private _MensajeServices: MensajeServices){
    this.Alertas = new Alertas(_MensajeServices);
  }

  ngOnInit(): void {
    this.AsignarConstantes();
    this.AsignarMensajes();
    this._ValidarAdmin();
    this._ObtenerCod();
  }

  private _ValidarAdmin(){
    this._AplicacionServices.ValidarAdmin().then(data => {
      if(data.StatusCode === 200){
        this.SoloAdmin = data.Data;
      }
    })
  }

  private _ObtenerCod(){
    let codigo: string | null = null;
    const urlParams = new URLSearchParams(window.location.search);
    codigo = urlParams.get('code');

    if (!codigo) {
      const pathSegments = window.location.pathname.split('/');
      const codeIndex = pathSegments.indexOf('code');
      if (codeIndex !== -1 && codeIndex < pathSegments.length - 1) {
        codigo = pathSegments[codeIndex + 1];
      }
    }
    console.log(codigo);
    if (codigo != null){
      this._AplicacionServices.ValidarToken(codigo).then(data => {
        if(data.StatusCode === 200){
          this.RedirectThkPag = data.Data;
          if (this.RedirectThkPag){
            window.location.replace(`${this.UrlThkPage}?Mensaje=${this.MensajeThkPag}`);
          }
          this.Alertas.MostrarAlerta('Verificación de correo', 'TokenIncorrecto', TiposAlerta.error);
        }
      })
    }
  }

  AsignarConstantes(): void {
    this._AplicacionServices.ObtenerConstante().then(data => {
      this.Constantes = data;
      this.UrlThkPage = data['UrlThankyouPage'];
    });
  }
  
  AsignarMensajes (): void {
    this._MensajeServices.CargarMensajes().then(data => {
      this.Mensajes = data;
      this.MensajeThkPag = data['DatosComerciales_Mensaje_Correo_Correcto'];
    });
  }
}
